import { portalPaths, UrlParams } from '@provision/portal-routes';
import { useEffect, useMemo } from 'react';
import { matchPath } from 'react-router-dom';
import { getRoutePath } from 'src/routes/utils';
import { useSelectedConversation } from 'src/store';
import { useNavigateRoute } from 'src/utils/routing';

export const SelectedEntitySync = () => {
  const { pathnameWithoutPrefix: path } = useNavigateRoute();
  const conversationPathPatterns = useMemo(
    () => [
      getRoutePath(portalPaths.conversation.full(UrlParams.recordId)),
      getRoutePath(portalPaths.conversation.allSelected(UrlParams.recordId)),
      getRoutePath(
        portalPaths.entity.selected('conversations', UrlParams.customViewId, UrlParams.recordId),
      ),
    ],
    [],
  );
  const { setSelectedConversationId } = useSelectedConversation();
  useEffect(() => {
    const match = conversationPathPatterns
      .map((pattern) => matchPath<'recordId', string>(pattern, path))
      .find((match) => !!match);
    const conversationId = match?.params.recordId ?? null;
    setSelectedConversationId(conversationId);
  }, [path, conversationPathPatterns, setSelectedConversationId]);
  return null;
};
